function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaticwebsiteBro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-253"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.5,108.18q-2.38-4-5-7.91C440.33,65.93,400.44,42.44,361.2,31.82a231.88,231.88,0,0,0-52.71-7.7c-116.62-3.95-163.07,88-201.61,111.68S9,200,13,285s65.22,165,183.81,170,126.5-48.42,192.71-68.19c43.82-13.08,75-57.26,90.2-98.08C500.5,233.08,499.52,160.81,468.5,108.18Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.5,108.18q-2.38-4-5-7.91C440.33,65.93,400.44,42.44,361.2,31.82a231.88,231.88,0,0,0-52.71-7.7c-116.62-3.95-163.07,88-201.61,111.68S9,200,13,285s65.22,165,183.81,170,126.5-48.42,192.71-68.19c43.82-13.08,75-57.26,90.2-98.08C500.5,233.08,499.52,160.81,468.5,108.18Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-253"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 26.71,
    y1: 467.36,
    x2: 488.2,
    y2: 467.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-253"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.62,63.83a10.27,10.27,0,1,0-10.26,10.26A10.27,10.27,0,0,0,371.62,63.83Z",
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.18,66.76V60.89h-6.85a17.07,17.07,0,0,0-2.9-7l4.84-4.84-4.14-4.15-4.85,4.84a17.29,17.29,0,0,0-7-2.9V40h-5.87v6.85a17.35,17.35,0,0,0-7,2.9l-4.85-4.84-4.14,4.15,4.84,4.84a17.35,17.35,0,0,0-2.9,7h-6.85v5.87h6.85a17.29,17.29,0,0,0,2.9,7l-4.84,4.85,4.14,4.14,4.85-4.84a17.07,17.07,0,0,0,7,2.9v6.85h5.87V80.8a17,17,0,0,0,7-2.9l4.85,4.84,4.14-4.14-4.84-4.85a17,17,0,0,0,2.9-7Z",
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.44,101.21a10.26,10.26,0,1,0-10.26,10.26A10.26,10.26,0,0,0,395.44,101.21Z",
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,104.14V98.28h-6.85a17.11,17.11,0,0,0-2.9-7l4.85-4.84L400,82.29l-4.85,4.85a17,17,0,0,0-7-2.9V77.39h-5.86v6.85a17.06,17.06,0,0,0-7,2.9l-4.84-4.85-4.15,4.15,4.84,4.84a17.24,17.24,0,0,0-2.89,7h-6.85v5.86h6.85a17.24,17.24,0,0,0,2.89,7L366.26,116l4.15,4.15,4.84-4.85a17.06,17.06,0,0,0,7,2.9V125h5.86v-6.85a17,17,0,0,0,7-2.9l4.85,4.85L404.1,116l-4.85-4.84a17.11,17.11,0,0,0,2.9-7Z",
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.72,
    y: 279.25,
    width: 44.28,
    height: 32.2,
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99 297.9 91.54 288.4 79.66 300.48 69.69 294.98 54.72 311.45 99 311.45 99 297.9",
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.15,
    cy: 287.06,
    r: 4.49,
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.91,
    y: 240.48,
    width: 44.28,
    height: 32.2,
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.18 259.13 63.73 249.63 51.84 261.71 41.88 256.21 26.91 272.69 71.18 272.69 71.18 259.13",
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.82,248.29a4.49,4.49,0,1,0-4.49,4.49A4.49,4.49,0,0,0,40.82,248.29Z",
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.94,
    y: 148.81,
    width: 52.79,
    height: 10.56,
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.94,
    y: 162.01,
    width: 52.79,
    height: 10.56,
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.94,
    y: 175.22,
    width: 52.79,
    height: 10.56,
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.94,
    y: 188.42,
    width: 52.79,
    height: 10.56,
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.94,
    y: 201.62,
    width: 52.79,
    height: 10.56,
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.17,154.39a1.94,1.94,0,1,0-1.93,1.93A1.93,1.93,0,0,0,443.17,154.39Z",
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.93,154.39a1.93,1.93,0,1,0-1.93,1.93A1.92,1.92,0,0,0,449.93,154.39Z",
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.24,
    cy: 167.27,
    r: 1.93,
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 448,
    cy: 167.27,
    r: 1.93,
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.24,
    cy: 180.16,
    r: 1.93,
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 448,
    cy: 180.16,
    r: 1.93,
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.17,193a1.94,1.94,0,1,0-1.93,1.93A1.93,1.93,0,0,0,443.17,193Z",
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.93,193A1.93,1.93,0,1,0,448,195,1.92,1.92,0,0,0,449.93,193Z",
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.24,
    cy: 205.92,
    r: 1.93,
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 448,
    cy: 205.92,
    r: 1.93,
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.05,
    cy: 281.92,
    r: 42,
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 441.05,
    cy: 281.92,
    rx: 19,
    ry: 42,
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.58,
    y1: 254.06,
    x2: 471.77,
    y2: 254.06,
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.58,
    y1: 309.96,
    x2: 471.77,
    y2: 309.96,
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 399.25,
    y1: 281.64,
    x2: 483.1,
    y2: 281.64,
    style: {
      fill: "none",
      stroke: "#ababab",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-253"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.14,
    cy: 379.49,
    rx: 10.49,
    ry: 27.51,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.6,
    cy: 359.94,
    rx: 19.61,
    ry: 8.53,
    transform: "translate(-270.12 350.64) rotate(-72.37)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.76,424.76c-10.68-1.81-18.69-7-17.91-11.69s10.09-6.95,20.76-5.14,18.7,7,17.91,11.69S46.44,426.57,35.76,424.76Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.22,
    cy: 391.88,
    rx: 22.74,
    ry: 10.49,
    transform: "translate(-242.54 194.76) rotate(-44.76)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.28,
    cy: 381.87,
    rx: 11.99,
    ry: 27.51,
    transform: "translate(-207.65 96.55) rotate(-34.58)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.87,
    y1: 405.64,
    x2: 81.69,
    y2: 443.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.9,
    y1: 369.26,
    x2: 80.87,
    y2: 405.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.97,
    y1: 363.33,
    x2: 79.9,
    y2: 366.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.85,402.74a105.41,105.41,0,0,1,10.36,39.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.84,375.17a124.41,124.41,0,0,1,18,27.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.17,369.18s1.08,1,2.87,2.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.72,406.62a124.22,124.22,0,0,0-17,33.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.79,392.75a100.09,100.09,0,0,0-12.07,13.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.68,382.93a55.1,55.1,0,0,0-9.19,6.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.28,376.07C93.47,394.36,85.67,421.38,82,444.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.82,365.23c-1,3.08-2.24,6.74-3.54,10.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.45,354.73s-1,2.8-2.65,7.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,417.09a28.76,28.76,0,0,1,17.8,18.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.57,414.36A45.69,45.69,0,0,1,56,417.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.88,414.58s1.29-.19,3.42-.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.13,424.76c10.68-1.81,18.7-7,17.91-11.69s-10.08-6.95-20.76-5.14-18.69,7-17.9,11.69S116.46,426.57,127.13,424.76Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.14,417c-7.34,2.73-14.54,8.05-18,18.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.45,414.31A46.53,46.53,0,0,0,107.14,417",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,414.58s-.85-.13-2.31-.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,467.36a51,51,0,0,0,5-21.66,44.85,44.85,0,0,0-2-13.24H54.09a44.85,44.85,0,0,0-2,13.24,51,51,0,0,0,5,21.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.66,438.65c-.16,1-.28,2.05-.37,3.1h59.48c-.09-1.05-.21-2.08-.37-3.1Z",
    style: {
      fill: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.14,454.47c.19-1,.35-2.06.47-3.1H52.45c.12,1,.28,2.07.47,3.1Z",
    style: {
      fill: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.33,445.87a2.41,2.41,0,1,1-2.41-2.41A2.41,2.41,0,0,1,59.33,445.87Z",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.37,445.87A2.41,2.41,0,1,1,69,443.46,2.41,2.41,0,0,1,71.37,445.87Z",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.41,445.87A2.41,2.41,0,1,1,81,443.46,2.41,2.41,0,0,1,83.41,445.87Z",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.44,445.87a2.41,2.41,0,1,1-2.4-2.41A2.41,2.41,0,0,1,95.44,445.87Z",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.48,445.87a2.41,2.41,0,1,1-2.41-2.41A2.41,2.41,0,0,1,107.48,445.87Z",
    style: {
      fill: "#8c8c8c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-253"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.92,275.71H414.47a12.74,12.74,0,0,1,12.74,12.74V454.22a0,0,0,0,1,0,0h-275a0,0,0,0,1,0,0V288.44A12.74,12.74,0,0,1,164.92,275.71Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.82,
    y: 445.63,
    width: 189.01,
    height: 9.31,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.82,
    y: 450.11,
    width: 189.01,
    height: 4.83,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.94,460.46s3.1,3.79,12.42,6.9H438.29s6.89-1.73,10-6.56Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.33,460.91H132.94a3.62,3.62,0,0,1-3.63-3.62h0a3.63,3.63,0,0,1,3.63-3.63H445.33a3.64,3.64,0,0,1,3.63,3.63h0A3.63,3.63,0,0,1,445.33,460.91Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.05,281.11a2.42,2.42,0,1,0-2.42,2.41A2.42,2.42,0,0,0,292.05,281.11Z",
    style: {
      fill: "#949494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.77,325.94h0a.69.69,0,0,1-.69-.69v-20a.69.69,0,0,1,.69-.69h0a.69.69,0,0,1,.69.69v20A.68.68,0,0,1,154.77,325.94Z",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinejoin: "round",
      strokeWidth: "0.691688px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.34,
    y: 289.65,
    width: 252.71,
    height: 142.81,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.85,
    y1: 398.36,
    x2: 279.43,
    y2: 398.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.85,
    y1: 406.67,
    x2: 279.43,
    y2: 406.67,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.85,
    y1: 414.99,
    x2: 279.43,
    y2: 414.99,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.85,
    y1: 423.3,
    x2: 279.43,
    y2: 423.3,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.32,
    y: 396.47,
    width: 62.12,
    height: 28.77,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.44 413.13 339.97 404.64 323.3 415.43 315.45 409.87 288.32 425.24 350.44 425.24 350.44 413.13",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.96,
    cy: 405.46,
    r: 4.09,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.34,
    y: 289.65,
    width: 252.71,
    height: 98.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.34,
    y: 289.65,
    width: 252.71,
    height: 10.8,
    style: {
      fill: "#949494",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.91,
    y: 300.08,
    width: 8.13,
    height: 132.39,
    style: {
      fill: "#949494",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.91,
    y: 322.87,
    width: 8.13,
    height: 39.36,
    style: {
      fill: "#696969",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "167.7 384.77 235.08 343.62 307.33 383.4 361.63 338.68 407.71 378.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "205.62 361.49 217.69 358.11 226.87 364.38 237.49 357.63 246.18 361.97 251.98 357.63 261.05 357.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "340.82 356.18 352.89 361.49 360.13 353.76 367.85 360.04 376.55 351.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.86,337.31h46.33s0-2.81-1.41-3.86a2.61,2.61,0,0,0-.95-.39,8.91,8.91,0,0,1-6.16-4.6,5.5,5.5,0,0,0-4.12-3.08c-5.61-1.05-4.91,3.86-8.07,4.21s-5.27-6-10.53-6-7,8.43-7,8.43-3.51-3.86-6.67.35S189.86,337.31,189.86,337.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.75,337.31h21.62s0-1.31-.66-1.8a1.19,1.19,0,0,0-.44-.18,4.16,4.16,0,0,1-2.88-2.15,2.57,2.57,0,0,0-1.92-1.44c-2.62-.49-2.29,1.8-3.77,2s-2.45-2.79-4.91-2.79-3.28,3.94-3.28,3.94a1.91,1.91,0,0,0-3.11.16C287.93,337,288.75,337.31,288.75,337.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.82,337.31h21.62s0-1.31-.66-1.8a1.19,1.19,0,0,0-.44-.18,4.16,4.16,0,0,1-2.88-2.15,2.57,2.57,0,0,0-1.92-1.44c-2.62-.49-2.29,1.8-3.77,2s-2.45-2.79-4.91-2.79-3.28,3.94-3.28,3.94a1.91,1.91,0,0,0-3.11.16C172,337,172.82,337.31,172.82,337.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.1,352.57c0,12.49-3.41,22.62-7.61,22.62s-7.61-10.13-7.61-22.62,3.41-34.88,7.61-34.88S348.1,340.08,348.1,352.57Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.27 387.5 340.18 333.2 342.01 387.96 339.27 387.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.12,361.65c0,9.29-2.54,16.81-5.66,16.81s-5.66-7.52-5.66-16.81,2.54-25.93,5.66-25.93S276.12,352.36,276.12,361.65Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.55 387.62 270.23 347.25 271.59 387.96 269.55 387.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.2,361.65c0,9.29-2.53,16.81-5.65,16.81s-5.66-7.52-5.66-16.81,2.53-25.93,5.66-25.93S400.2,352.36,400.2,361.65Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.64 387.62 394.32 347.25 395.67 387.96 393.64 387.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.34,
    y: 300.08,
    width: 252.71,
    height: 11.93,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.19,
    y1: 312.26,
    x2: 193.19,
    y2: 300.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225.28,
    y1: 312.26,
    x2: 225.28,
    y2: 300.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.38,
    y1: 312.26,
    x2: 257.38,
    y2: 300.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 289.47,
    y1: 312.26,
    x2: 289.47,
    y2: 300.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 321.57,
    y1: 312.26,
    x2: 321.57,
    y2: 300.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 353.67,
    y1: 312.26,
    x2: 353.67,
    y2: 300.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385.76,
    y1: 312.26,
    x2: 385.76,
    y2: 300.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.22,
    y: 291.85,
    width: 92,
    height: 4.99,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.86,294.34a2,2,0,1,1-2-2A2,2,0,0,1,393.86,294.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.47,294.34a2,2,0,1,1-2-2A2,2,0,0,1,402.47,294.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.08,294.34a2,2,0,1,1-2-2A2,2,0,0,1,411.08,294.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-253"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.64,204.37v-9.73l-11.12-1.17a22.63,22.63,0,0,0-2.06-5.09l7.09-8.76-6.88-6.87-8.69,7a22.82,22.82,0,0,0-5.05-2.14l-1.18-11.2H315l-1.17,11.11a22,22,0,0,0-5.09,2.07l-8.76-7.1-6.88,6.88,7,8.69a22.36,22.36,0,0,0-2.14,5l-11.21,1.18v9.73l11.12,1.17a22.63,22.63,0,0,0,2.06,5.09l-7.09,8.75,6.87,6.88,8.69-7a22.43,22.43,0,0,0,5.06,2.14l1.18,11.21h9.72l1.17-11.11a22.47,22.47,0,0,0,5.09-2.07l8.76,7.09,6.87-6.87-7-8.69a22.43,22.43,0,0,0,2.14-5.06Zm-32.91,10.42a15.45,15.45,0,1,1,15.44-15.45A15.45,15.45,0,0,1,319.73,214.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.86,171.57V164.4l-8.2-.87a16.85,16.85,0,0,0-1.52-3.75l5.23-6.46-5.07-5.07-6.41,5.19a16.59,16.59,0,0,0-3.73-1.58l-.87-8.27h-7.17l-.87,8.2a16.85,16.85,0,0,0-3.75,1.52L352,148.08,347,153.15l5.19,6.41a16.21,16.21,0,0,0-1.58,3.73l-8.27.87v7.17l8.2.87A16.38,16.38,0,0,0,352,176l-5.23,6.46,5.07,5.07,6.41-5.19a16.21,16.21,0,0,0,3.73,1.58l.87,8.27h7.17l.87-8.2a16.85,16.85,0,0,0,3.75-1.52l6.46,5.23,5.07-5.07L381,176.17a16.21,16.21,0,0,0,1.58-3.73Zm-24.28,7.69a11.4,11.4,0,1,1,11.4-11.4A11.39,11.39,0,0,1,366.58,179.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 278.49,
    y1: 125.15,
    x2: 279.99,
    y2: 125.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.95,
    y1: 125.15,
    x2: 328.72,
    y2: 125.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeDasharray: "2.9531900882720947,2.9531900882720947"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "330.2 125.14 331.7 125.14 331.7 126.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.7,
    y1: 129.77,
    x2: 331.7,
    y2: 171.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeDasharray: "3.126039981842041,3.126039981842041"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.7,
    y1: 173.54,
    x2: 331.7,
    y2: 175.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.7,
    y1: 233.84,
    x2: 331.7,
    y2: 235.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.7,
    y1: 238.72,
    x2: 331.7,
    y2: 257.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeDasharray: "3.38959002494812,3.38959002494812"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.7,
    y1: 259.06,
    x2: 331.7,
    y2: 260.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.78 271.05 341.82 253.66 321.74 253.66 331.78 271.05",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Template--inject-253"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105.98,
    y: 59,
    width: 166.26,
    height: 200.83,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.98,
    y: 59,
    width: 166.26,
    height: 11.32,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.98,
    y: 59,
    width: 166.26,
    height: 11.32,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.37,
    y: 75.09,
    width: 16.69,
    height: 116.8,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.37,
    y: 75.09,
    width: 16.69,
    height: 116.8,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.01,
    y: 71.53,
    width: 10.25,
    height: 186.14,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.62,
    y: 80.82,
    width: 101.12,
    height: 145.66,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.62,
    y: 80.82,
    width: 101.12,
    height: 46.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.62,
    y: 124.18,
    width: 101.12,
    height: 3.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.43,
    y1: 136.5,
    x2: 175.03,
    y2: 136.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.43,
    y1: 142.3,
    x2: 175.03,
    y2: 142.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.43,
    y1: 148.1,
    x2: 175.03,
    y2: 148.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.43,
    y1: 153.89,
    x2: 175.03,
    y2: 153.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.43,
    y1: 159.69,
    x2: 175.03,
    y2: 159.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.43,
    y1: 165.48,
    x2: 175.03,
    y2: 165.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.43,
    y1: 171.28,
    x2: 175.03,
    y2: 171.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.43,
    y1: 177.08,
    x2: 175.03,
    y2: 177.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.42,
    y1: 206.45,
    x2: 171.03,
    y2: 206.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.42,
    y1: 212.24,
    x2: 171.03,
    y2: 212.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.42,
    y1: 218.04,
    x2: 171.03,
    y2: 218.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.38,
    y1: 206.45,
    x2: 198.99,
    y2: 206.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.38,
    y1: 212.24,
    x2: 198.99,
    y2: 212.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.38,
    y1: 218.04,
    x2: 198.99,
    y2: 218.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.34,
    y1: 206.45,
    x2: 226.95,
    y2: 206.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.34,
    y1: 212.24,
    x2: 226.95,
    y2: 212.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.34,
    y1: 218.04,
    x2: 226.95,
    y2: 218.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.62,
    y: 80.82,
    width: 101.12,
    height: 3.9,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 149.62,
    y1: 81.14,
    x2: 149.62,
    y2: 84.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.04,
    y1: 81.14,
    x2: 162.04,
    y2: 84.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.45,
    y1: 81.14,
    x2: 174.45,
    y2: 84.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.87,
    y1: 81.14,
    x2: 186.87,
    y2: 84.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.29,
    y1: 81.14,
    x2: 199.29,
    y2: 84.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.71,
    y1: 81.14,
    x2: 211.71,
    y2: 84.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 224.13,
    y1: 81.14,
    x2: 224.13,
    y2: 84.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 136.62,
    y1: 124.18,
    x2: 237.74,
    y2: 84.72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 136.62,
    y1: 84.72,
    x2: 237.74,
    y2: 124.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.35,
    y: 132.23,
    width: 36.53,
    height: 19.57,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.35,
    y: 154.21,
    width: 36.53,
    height: 19.57,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.35,
    y: 176.18,
    width: 36.53,
    height: 19.57,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.35,
    y1: 132.23,
    x2: 214.87,
    y2: 151.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.87,
    y1: 132.23,
    x2: 178.35,
    y2: 151.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.35,
    y1: 154.21,
    x2: 214.87,
    y2: 173.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.87,
    y1: 154.21,
    x2: 178.35,
    y2: 173.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.35,
    y1: 176.18,
    x2: 214.87,
    y2: 195.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.87,
    y1: 176.18,
    x2: 178.35,
    y2: 195.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.95,
    y: 106.56,
    width: 41.12,
    height: 36.35,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.65 106.56 248.65 110.75 221.95 110.75 221.95 142.91 263.07 142.91 263.07 106.56 248.65 106.56",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.95,
    y: 106.56,
    width: 26.69,
    height: 4.19,
    style: {
      fill: "#fff",
      opacity: 0.18
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.42,
    y: 112.93,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.22,
    y: 112.93,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.02,
    y: 112.93,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.81,
    y: 112.93,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.61,
    y: 112.93,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.41,
    y: 112.93,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.2,
    y: 112.93,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.42,
    y: 117.81,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.22,
    y: 117.81,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.02,
    y: 117.81,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.81,
    y: 117.81,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.61,
    y: 117.81,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.41,
    y: 117.81,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.2,
    y: 117.81,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.42,
    y: 122.69,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.22,
    y: 122.69,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.02,
    y: 122.69,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.81,
    y: 122.69,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.61,
    y: 122.69,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.41,
    y: 122.69,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.2,
    y: 122.69,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.42,
    y: 127.56,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.22,
    y: 127.56,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.02,
    y: 127.56,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.81,
    y: 127.56,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.61,
    y: 127.56,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.41,
    y: 127.56,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.2,
    y: 127.56,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.42,
    y: 132.44,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.22,
    y: 132.44,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.02,
    y: 132.44,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.81,
    y: 132.44,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.61,
    y: 132.44,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.41,
    y: 132.44,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.2,
    y: 132.44,
    width: 4.39,
    height: 4.39,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.12,
    y: 112.88,
    width: 3.03,
    height: 24.33,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Content--inject-253"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 101,
    y1: 125.15,
    x2: 99.5,
    y2: 125.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.64,
    y1: 125.15,
    x2: 75.22,
    y2: 125.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeDasharray: "2.8565800189971924,2.8565800189971924"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "73.79 125.14 72.29 125.14 72.29 123.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.29,
    y1: 120.61,
    x2: 72.29,
    y2: 110.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeDasharray: "3.0309500694274902,3.0309500694274902"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.29,
    y1: 108.49,
    x2: 72.29,
    y2: 106.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.72 124.81 85.33 114.77 85.33 134.85 102.72 124.81",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.2 91.72 34.36 91.72 34.36 39.94 68.36 39.94 73.2 46.84 73.2 91.72",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.36 39.94 68.36 47.45 73.2 47.45 68.36 39.94",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.32,
    y1: 54.76,
    x2: 67.45,
    y2: 54.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.32,
    y1: 62.08,
    x2: 67.45,
    y2: 62.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.32,
    y1: 69.39,
    x2: 67.45,
    y2: 69.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.32,
    y1: 76.71,
    x2: 67.45,
    y2: 76.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.91,
    y: 54.15,
    width: 21.03,
    height: 37.49,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.83 103.61 56 103.61 56 51.83 90 51.83 94.83 58.73 94.83 103.61",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90 51.83 90 59.34 94.83 59.34 90 51.83",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.96,
    y1: 66.65,
    x2: 89.09,
    y2: 66.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.96,
    y1: 73.97,
    x2: 89.09,
    y2: 73.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.96,
    y1: 81.28,
    x2: 89.09,
    y2: 81.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.96,
    y1: 88.59,
    x2: 89.09,
    y2: 88.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticwebsiteBro);
export default __webpack_public_path__ + "static/media/Static website-bro.b71f93fc74eb388925a111db51f7d62b.svg";
export { ForwardRef as ReactComponent };